module.exports = __webpack_public_path__ + "img/bg.c22fa970.png";